import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useHistory, useLocation } from "react-router-dom";
import queryString from "query-string";

import ScreenLayout from "components/ScreenLayout";
import ItemListFilters from "screens/InventoryItems/components/ItemListFilters";
import ItemsTable from "screens/InventoryItems/components/ItemsTable";
import categoryItemsHeaderComponents from "screens/InventoryItems/components/productItemsHeaderComponents";
import { useInventoryNavigation } from "contexts/InventoryNavigationContext";

import {
  fetchSingleCategory,
  unsetSelectedCategory,
} from "store/category/actions";
import { unsetSelectedItem } from "store/item/actions";

import { ERROR_STATUS_NOT_FOUND } from "components/MessageService/constants";

import "./styles.scss";

const InventoryItems = () => {
  const params = useParams();
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const [columns, setColumns] = useState([]);
  const hasSyncedRef = useRef(false);
  const lastPathnameRef = useRef('');

  const { selected: selectedCategory } = useSelector(
    ({ categoryReducer }) => categoryReducer
  );
  const { messagePayload } = useSelector(({ helperReducer }) => helperReducer);
  const { getSavedColumns } = useInventoryNavigation();

  useEffect(() => {
    dispatch(unsetSelectedItem());

    if (params.categoryId) {
      dispatch(fetchSingleCategory(params.categoryId));
    } else {
      dispatch(unsetSelectedCategory());
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  // Sincronizar categoryId de la ruta con query params para que el filtro lo muestre
  // Solo sincronizar una vez cuando cambia el categoryId de la ruta
  useEffect(() => {
    // Resetear si cambió el pathname
    if (lastPathnameRef.current !== location.pathname) {
      hasSyncedRef.current = false;
      lastPathnameRef.current = location.pathname;
    }

    if (params.categoryId && !hasSyncedRef.current) {
      const searchParams = queryString.parse(location.search);
      
      // Solo actualizar si el categoryId de la ruta no está en los query params
      // Esto permite que el filtro muestre la categoría cuando viene desde la ruta
      if (searchParams.category !== params.categoryId) {
        const newSearchParams = new URLSearchParams(location.search);
        newSearchParams.set('category', params.categoryId);
        
        history.replace({
          pathname: location.pathname,
          search: newSearchParams.toString()
        });
      }
      hasSyncedRef.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.categoryId, location.pathname]);

  
  useEffect(() => {
    const saved = getSavedColumns();
    if (saved && Array.isArray(saved) && saved.length > 0) {
      setColumns(saved);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const handleNavigation = () => {
      if (messagePayload) {
        if (
          params.categoryId &&
          messagePayload.type === ERROR_STATUS_NOT_FOUND
        ) {
          history.push("/category/items");
        }
      }
    };

    handleNavigation();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messagePayload, params]);

  return (
    <ScreenLayout
      headerComponents={categoryItemsHeaderComponents(selectedCategory)}
      contentContainerStyle={{ marginTop: 0 }}
    >
      <ItemListFilters setColumns={setColumns} columns={columns} />
      <ItemsTable columns={columns} />
    </ScreenLayout>
  );
};

export default InventoryItems;
